
var winWidth    = $(window).width();
var winHeight   = $(window).height();
var scrollTop   = $(window).scrollTop();
var breakpoint  = {'pc': 1200, 'tb': 992, 'sp': 768};
var headerTag   = $('.l-header');



$(document).ready(function() {

  // slideout
  var slideout = new Slideout({
    'panel': document.getElementById('js-so_panel'),
    'menu': document.getElementById('js-so_menu'),
    'duration': 10,
    // 'openclass': 'slideout-open',
  });
  var nodeList = document.querySelectorAll('#js-so_toggle, #js-so_panel');
  var node = Array.prototype.slice.call(nodeList,0);
  node.forEach(function(elem, index){
    elem.addEventListener('click', function() {
      slideout.toggle();
    });
  });
  var nodeListClose = document.querySelectorAll('#js-so_menu .js-scroll');
  var nodeClose = Array.prototype.slice.call(nodeListClose,0);
  nodeClose.forEach(function(elem, index){
    elem.addEventListener('click', function() {
      slideout.close();
    });
  });


  // table_wrap
  if ( document.getElementById('js-editor') != null ) {
    $('#js-editor table').each(function() {
      $(this).wrap('<div class="c-tblwrap"></div>');
    });
  }


  // // tab
  // $('.js-tabbtn').each(function(){
  //   $('> li > a', this).on('click', function(){
  //     var tabHref   = $(this).attr('href');
  //     var clickWrap = $(this).closest('.js-tabbtn');
  //     var tabObj    = clickWrap.find('a');
  //     var contsObj  = clickWrap.next('.js-tabconts').children('div');

  //     tabObj.removeClass('is-act');
  //     $(this).addClass('is-act');

  //     contsObj.hide();
  //     $(tabHref).fadeIn();

  //     return false;
  //   }).eq(0).click();
  // });


  // accordion
  $('.js-accordion').on('click', function(){
    if ( $(this).hasClass('is-act') ) {
      $(this).removeClass('is-act').next().stop().slideUp('fast');
      // $(this).removeClass('is-act');
    } else {
      $(this).addClass('is-act').next().stop().slideDown();
      // $(this).addClass('is-act');
    }
  });



  // slick
  $('.js-sld_bg').slick({
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 1000,
    arrows: false,
    dots: false,
    pauseOnFocus: false,
    pauseOnHover: false,
    asNavFor: '.js-sld_fr'
  });
  $('.js-sld_fr').slick({
    fade: true,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 1000,
    cssEase: 'linear',
    arrows: false,
    dots: true,
    pauseOnFocus: false,
    pauseOnHover: false,
    asNavFor: '.js-sld_bg'
  });

  $('.js-sld_main').slick({
    infinite: false,
    fade: true,
    autoplay: false,
    autoplaySpeed: 5000,
    speed: 400,
    cssEase: 'linear',
    arrows: false,
    dots: false,
    pauseOnFocus: false,
    pauseOnHover: false,
    asNavFor: '.js-sld_sub',
  });
  $('.js-sld_sub').slick({
    infinite: false,
    autoplay: false,
    autoplaySpeed: 5000,
    speed: 400,
    slidesToShow: 4,
    arrows: true,
    prevArrow: '<button class="slick-prev-cus slick-arrow" aria-label="Previous" type="button"></button>',
    nextArrow: '<button class="slick-next-cus slick-arrow" aria-label="Next" type="button"></button>',
    dots: false,
    pauseOnFocus: false,
    pauseOnHover: false,
    asNavFor: '.js-sld_main',
    focusOnSelect: true,
    responsive:[
      {
        breakpoint: 992,
        settings:{
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 768,
        settings:{
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 576,
        settings:{
          slidesToShow: 3,
        }
      },
    ]
  });
  // $('.js-sld_pickup').slick({
  //   autoplay: true,
  //   autoplaySpeed: 5000,
  //   speed: 1200,
  //   slidesToShow: 3,
  //   arrows: true,
  //   prevArrow: '<button class="slick-prev-cus slick-arrow" aria-label="Previous" type="button"></button>',
  //   nextArrow: '<button class="slick-next-cus slick-arrow" aria-label="Next" type="button"></button>',
  //   dots: false,
  //   pauseOnFocus: false,
  //   pauseOnHover: false,
  //   responsive:[
  //     {
  //       breakpoint: 992,
  //       settings:{
  //         slidesToShow: 2,
  //       }
  //     },
  //     {
  //       breakpoint: 768,
  //       settings:{
  //         slidesToShow: 2,
  //         arrows: false,
  //         dots: true,
  //       }
  //     },
  //   ]
  // });


});

